import { graphql } from "@/gql";

export const createWorkOrderAssignmentPayout = graphql(`
  mutation CreateWorkOrderAssignmentPayoutMutation(
    $input: CreateWorkOrderAssignmentPayoutInput!
  ) {
    createWorkOrderAssignmentPayout(input: $input) {
      id
      status
      amount
      amount_tax
      currency
      transaction_reference
      paid_at
    }
  }
`);

export const updateWorkOrderAssignmentPayout = graphql(`
  mutation UpdateWorkOrderAssignmentPayoutMutation(
    $id: ID!
    $input: UpdateWorkOrderAssignmentPayoutInput!
  ) {
    updateWorkOrderAssignmentPayout(id: $id, input: $input) {
      id
      status
      amount
      amount_tax
      currency
      transaction_reference
      paid_at
    }
  }
`);

export const deleteWorkOrderAssignmentPayout = graphql(`
  mutation DeleteWorkOrderAssignmentPayoutMutation($id: ID!) {
    deleteWorkOrderAssignmentPayout(id: $id) {
      id
    }
  }
`);

export const resendPayoutEmail = graphql(`
  mutation ResendPayoutEmailMutation($id: ID!) {
    resendPayoutEmail(id: $id) {
      id
    }
  }
`);
